/* eslint-disable no-unused-vars */
import { useSelector } from "react-redux";
import React, { useState } from "react";
import { ICalendar, TextField, VStack } from "../../../components";
import { CnpForm, IPaymentTerms } from "../../../types";
import { DatePicker } from "../../../components/DatePicker/DatePicker";
import { Modal } from "../../../components/Modal/Modal";
import greenCheck from "../../../assets/green-check.svg";
import "./PaymentTerms.css";

import { getTotalAmountForLineItemArray, getTotalVatAmountForLineItemArray } from "../../../utils/Calculation";
import { numberWithSpaces } from "../../../utils/utils";
import { getFromSessionStorage, StorageKeys } from "../../../utils/Storage";

type PaymentTermsData = {
  paymentTerms: IPaymentTerms;
};

export interface PaymentTermsProps {
  data: CnpForm;
  canProceed: any;
  updateData: (fields: Partial<PaymentTermsData>) => void;
}

export const PaymentTerms = ({ data, canProceed, updateData }: PaymentTermsProps) => {
  const merchantDetails = useSelector(
    // @ts-ignore
    (state) => state.authenticationReducer.merchantDetails,
  );
  const { companyName } = merchantDetails;
  const { lineItems } = data;

  const { paymentTerms } = data;

  const [isDueDateModalOpen, setDueDateModalOpen] = useState(false);

  const onDateIconClick = (): void => {
    if (!isDueDateModalOpen) setDueDateModalOpen(true);
  };

  canProceed(true);

  const today = new Date();

  const onDateCancel = (): void => {
    updateData({
      paymentTerms: { ...paymentTerms, dueDate: today.toString() },
    });
    setDueDateModalOpen(false);
  };

  const totalAmountForLineItemArray = getTotalAmountForLineItemArray(lineItems);
  const totalVatAmountForLineItemArray = getTotalVatAmountForLineItemArray(lineItems);

  const getDueDate = new Date(paymentTerms.dueDate);
  return (
    <VStack className="d-flex align-items-center direction-column px-0">
      <div className="summary">
        <div className="subtotal">
          <div className="title">Subtotal</div>
          <div className="amount">
            R {numberWithSpaces((totalAmountForLineItemArray - totalVatAmountForLineItemArray).toFixed(2))}
          </div>
        </div>
        <div className="vat">
          <div className="title">VAT (15%)</div>
          <div className="amount">R {numberWithSpaces(totalVatAmountForLineItemArray.toFixed(2))}</div>
        </div>
        <div className="divider" />
        <div className="total">
          <div className="title">Total Due</div>
          <div className="amount">R {numberWithSpaces(totalAmountForLineItemArray.toFixed(2))}</div>
        </div>
      </div>
      <div className="terms-input-fields">
        <TextField
          className="clickable"
          label="Due Date"
          name="dueDate"
          type="text"
          placeholder=""
          required
          minLength={10}
          maxLength={25}
          onFocus={() => setDueDateModalOpen(true)}
          value={getDueDate.toLocaleString("en-ZA", {
            day: "numeric",
            month: "long",
            year: "numeric",
          })}
          icon={<ICalendar width="24px" height="24px" onClick={onDateIconClick} />}
          onChange={() => {}}
        />
        <div>
          <div className="invoice-number">Invoice Number (optional)</div>
          <div className="invoice-number-input">
            <input
              type="text"
              placeholder={getFromSessionStorage(StorageKeys.INVOICE_REFERENCE) || ""}
              maxLength={20}
              value={paymentTerms.invoiceNumber}
              onChange={(e) => {
                updateData({
                  paymentTerms: {
                    ...paymentTerms,
                    invoiceNumber: e.target.value,
                  },
                });
              }}
            />
          </div>
          <div className="counter">
            <span className="input-description">Should you not enter a value, the placeholder value will be used as default</span>
          </div>
        </div>
        <div>
          <div className="additional-notes">Additional Notes (optional)</div>
          <div className="input-area">
            <textarea
              value={paymentTerms.additionalNotes}
              maxLength={250}
              id="text-area"
              onChange={(e) => {
                updateData({
                  paymentTerms: {
                    ...paymentTerms,
                    additionalNotes: e.target.value,
                  },
                });
              }}
            />
            <div className="image">
              {paymentTerms.additionalNotes && paymentTerms.additionalNotes.length >= 1 && (
                <img src={greenCheck} alt="green-check" />
              )}
            </div>
          </div>
          <div className="input-description">
            <span className="description">Max 250 characters</span>
            <span className="count">
              <span id="current">{paymentTerms.additionalNotes?.length}</span>
              <span id="limit">/250</span>
            </span>
          </div>
        </div>
      </div>
      <Modal
        isOpen={isDueDateModalOpen}
        content={
          <DatePicker
            selectedDate={getDueDate}
            onChange={(newDate) =>
              updateData({
                paymentTerms: {
                  ...paymentTerms,
                  dueDate: newDate.toISOString(),
                },
              })
            }
            currentDate={today}
            onCancel={onDateCancel}
            onSubmit={() => setDueDateModalOpen(false)}
          />
        }
      />
    </VStack>
  );
};
